import * as React from 'react'
import ButtonPrimary from '@/components/ButtonPrimary'
import Curve from '@/svg/curves'
import Image from 'next/image'

import { StandardPageQuery_entry_page_page_Entry_modules_modules_secondaryBanner_BlockType } from '@/gql/types/StandardPageQuery'
import { SiteWideQuery_globalSet } from '@/gql/types/SiteWideQuery'

import { colourMapping, fillMapping } from '@/config/ts/tailwind'

import { motion } from 'framer-motion'
import { fadeIn } from '@/lib/utils/framer-motion-config'

type SecondaryBannerType = {
    data: StandardPageQuery_entry_page_page_Entry_modules_modules_secondaryBanner_BlockType
    siteWide: SiteWideQuery_globalSet
}

const SecondaryBanner: React.FunctionComponent<SecondaryBannerType> = ({ data, siteWide }) => {
    const image = data.image![0]!

    const [dynamicClass, setDynamicClass] = React.useState(
        data.theme ? colourMapping[data.theme] : colourMapping['purple']
    )

    React.useEffect(() => {
        setDynamicClass(colourMapping[data.theme!])
    }, [data.theme])

    return (
        <>
            <section className="mb-20 md:mb-[120px]">
                <div
                    className={`${dynamicClass} ${
                        dynamicClass == 'bg-purple' ? 'text-white' : 'text-black'
                    }`}
                >
                    <div className="justify-between pt-32 pl-5 pb-14 md:pt-40 md:pl-10 md:pb-20 lg:flex lg:pt-[208px] lg:pb-[140px] lg:pl-20">
                        <div className="mb:mb-[60px] mb-10 items-center justify-center pr-5 md:pr-10 lg:mb-0 lg:flex lg:w-2/3 lg:pr-20">
                            <div className="max-w-[760px]">
                                <motion.h1
                                    className="font-sans text-4xl font-black leading-[40px] md:text-5xl md:leading-[48px] xl:text-6xl xl:leading-[70px]"
                                    {...fadeIn}
                                >
                                    {data?.heading!}
                                </motion.h1>
                                {data.children && (
                                    <ul className="flex-column mt-6 flex w-full max-w-[300px] flex-wrap space-y-5 md:mt-10 md:max-w-[700px] md:flex-row md:space-y-0 md:space-x-6 lg:min-w-[700px]">
                                        {data.children.map((item, index) => {
                                            const newData: any = item!
                                            return (
                                                <motion.li
                                                    {...fadeIn}
                                                    key={index}
                                                    className="w-full max-w-[266px] sm:max-w-[300px]"
                                                >
                                                    {item && (
                                                        <ButtonPrimary
                                                            data={newData}
                                                            theme={data.theme}
                                                            onClick={() => {
                                                                const section =
                                                                    document.querySelector(
                                                                        newData.block
                                                                    )
                                                                section?.scrollIntoView({
                                                                    behavior: 'smooth',
                                                                    offset: '100px',
                                                                })
                                                            }}
                                                        />
                                                    )}
                                                </motion.li>
                                            )
                                        })}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className="flex justify-between lg:w-1/3">
                            <div className="hidden sm:block sm:w-1/3 lg:w-1/6" />
                            {image && (
                                <motion.div
                                    {...fadeIn}
                                    className="relative sm:w-2/3 lg:w-5/6"
                                >
                                    <Image
                                        src={image.src!}
                                        alt={image.alt ? image.alt : ''}
                                        layout="intrinsic"
                                        width={900}
                                        height={600}
                                    />
                                </motion.div>
                            )}
                        </div>
                    </div>
                </div>
                {Curve(`${data.theme ? fillMapping[data.theme] : fillMapping['purple']}`)}
            </section>
        </>
    )
}

export default SecondaryBanner
